<script>
  // lib
  import { tweened } from "svelte/motion";

  // store
  import PollStore from "../stores/PollStore";

  // components
  import Card from "../shared/Card.svelte";
  import Button from "../shared/Button.svelte";

  export let poll;

  // reactive values
  $: totalVotes = poll.voteA + poll.voteB;
  $: percentA = Math.floor((100 / totalVotes) * poll.voteA) || 0;
  $: percentB = Math.floor((100 / totalVotes) * poll.voteB) || 0;

  // tweened percentages
  const tweenedA = tweened(0);
  const tweenedB = tweened(0);
  $: tweenedA.set(percentA);
  $: tweenedB.set(percentB);

  // handle vote
  const handleVote = (option, id) => {
    PollStore.update((currentPolls) => {
      let draftPolls = [...currentPolls];
      let upVotedPoll = draftPolls.find((poll) => poll.id === id);

      if (option === "a") upVotedPoll.voteA++;
      else if (option === "b") upVotedPoll.voteB++;

      return draftPolls;
    });
  };

  // deleting a poll
  const handleDelete = (id) => {
    PollStore.update((currentPolls) => {
      return currentPolls.filter((poll) => poll.id !== id);
    });
  };
</script>

<Card>
  <div class="poll">
    <h3>{poll.question}</h3>
    <p>Total votes: {totalVotes}</p>
    <div class="answer" on:click={() => handleVote("a", poll.id)}>
      <div class="percent percent-a" style="width: {$tweenedA}%" />
      <span>{poll.answerA} ({poll.voteA})</span>
    </div>
    <div class="answer" on:click={() => handleVote("b", poll.id)}>
      <div class="percent percent-b" style="width: {$tweenedB}%" />
      <span>{poll.answerB} ({poll.voteB})</span>
    </div>
    <div class="delete">
      <Button
        type="danger"
        flat={true}
        small={true}
        on:click={() => handleDelete(poll.id)}>Delete</Button
      >
    </div>
  </div>
</Card>

<style>
  h3 {
    margin: 0 auto;
    color: #555;
  }
  p {
    margin-top: 6px;
    font-size: 14px;
    color: #aaa;
    margin-bottom: 30px;
  }
  .answer {
    background: #fafafa;
    cursor: pointer;
    margin: 10px auto;
    position: relative;
  }
  .answer:hover {
    opacity: 0.6;
  }
  span {
    display: inline-block;
    padding: 10px 20px;
  }
  .percent {
    height: 100%;
    position: absolute;
    box-sizing: border-box;
  }
  .percent-a {
    border-left: 4px solid rgba(220, 53, 69, 1);
    background-color: rgba(220, 53, 69, 0.2);
  }
  .percent-b {
    border-left: 4px solid rgba(0, 175, 185, 1);
    background-color: rgba(0, 175, 185, 0.2);
  }
  .delete {
    margin-top: 30px;
    text-align: center;
  }
</style>
